<!--

  Author: dhersey
  Date: 02/14/2025
  Desc: New Events planner template, based off of BgPbEscape.vue and BgPlanVoyage.vue
    Going to draw from data, currently using testing data from 

-->

<template>
  
</template>

<script setup>
  import { ref, toRaw } from 'vue';

  let isDebug = false;

  let currentStep = ref();

  let step_labels = ["Overview", "Accommodations", "Activities", "Contact"];
  
</script>

<style scoped lang="scss">

</style>